module.exports = __webpack_public_path__ + "static/img/1.388e1fe4.png";